window.addEventListener("load", function() {
    const barData = [
      { barSelector: '.clinical-bar-1 .bar-inner', numberSelector: '.bar-number-1' },
      { barSelector: '.clinical-bar-2 .bar-inner', numberSelector: '.bar-number-2' },
      { barSelector: '.clinical-bar-3 .bar-inner', numberSelector: '.bar-number-3' }
    ];
  
    const tl = gsap.timeline({ paused: true });
  
    barData.forEach(data => {
      const trialPercentage = document.querySelector(data.numberSelector).textContent;
  
      gsap.set(data.barSelector, { scaleX: 0.1 });
      gsap.set(data.numberSelector, { textContent: 0 });
  
      tl.fromTo(data.barSelector, 5, { scaleX: 0.1 }, { scaleX: trialPercentage / 100, ease: "power3" }, "progress-start");
      tl.fromTo(data.numberSelector, 3.5, { textContent: 0, snap: { textContent: 1 }, stagger: 1 }, { textContent: trialPercentage, snap: { textContent: 1 }, stagger: 1 }, 'progress-start');
    });
  
    ScrollTrigger.create({
      trigger: ".clinical-results-bars-container",
      start: "top center",
      markers: false,
      onEnter: () => tl.play(),
      onEnterBack: () => tl.play()
    });
  });